import React, {useState} from "react";
import { Navbar, Image, Container, Row, Col } from "react-bootstrap";
import "./index.css";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
import morgannav from "../../Images/navbarmorganlogo.png";

export default function Header( { links } ){
const [navbar, setNavbar] = useState(false);

  const changebackground = () => {
    if(window.scrollY >= 20){
      setNavbar(true);
    }else{
      setNavbar(false);
    }
  };
  


  window.addEventListener('scroll', changebackground);
    return(
      <Container>
        <Navbar expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          className={navbar ? 'navbar active' : 'navbar'}>
            <Container>
              <Row className="headerlogos">
              <Col xl={6}>
                <a href="https://www.swmc.com/" target="_blank">
                    <Image src={process.env.REACT_APP_CDN_LINK + "swmc-images/sunwest-trust-white-logo.png"} 
                        alt="Sun West logo" title="Sun West logo" className="sunwest-logo mt-2" />
                </a>
                </Col>
                <Col xl={5}>
                <a href="https://www.angelai.com" target="_blank">
                    <img src= {links && links.brandTransitionGifs.previousToCurrentBrandNameStaticTransition}
                        alt="Angel Ai logo" title="Angel Ai-logo" className="morgan-university-logo mt-2" /> 
                        </a>
                </Col>
                </Row>
            </Container>
            <div className="desktop-AccessibilityMenu-show">
            <UserWayAccessibilityMenu color="white" width={40} height={40}/>
          </div>
          </Navbar>
          <div className="mobile-AccessibilityMenu-show">
        <UserWayAccessibilityMenu color="white" width={40} height={40}/>
      </div>
        
        </Container>
    );
}
